import React, {Component} from 'react';
import Dropzone from 'react-dropzone';
import PreloadingMask from './PreloadingMask';
import {Icon , Modal, Button} from 'antd';
import Cube from '../media/cubeload.gif';
import {urlPath} from './Settings';
import {checkMaxFileSize , highlightMaterial} from './Helpers';
import {getAuthHeader, handleErrors} from '../utils/security';

/*eslint no-loop-func: "off"*/
class AssetUploadBig extends Component {
	constructor(props) {
		super(props);
		this.state = {
			alertModalContent: null,
			className: "ix-creative-dropzone ix-asset-dropzone",
			files: [],
			printAd: null,
			strings: this.props.language,
			tableData: [],
			translations: this.props.translations || {},
			uploadedFileCloudinaryUrl: ''
		};
		this.handleOk = this.handleOk.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		!this.isCancelled && this.setState({
			strings: nextProps.language,
			translations: nextProps.translations
		});
	}

	handleDelete = () => {
		const {tableData, uploadFiles, selectedRowKeys} = this.state;
		console.log(uploadFiles);
		const uploadFilesTmpInit = uploadFiles;
		const uploadFilesTmpEnd = [];
		for(let value in selectedRowKeys)
			for(let file in tableData)
				if (tableData[file].key === selectedRowKeys[value]) {
					//uploadFiles.splice(file, 1);
					uploadFilesTmpEnd.push(uploadFilesTmpInit[file])
				}
		this.setState({
			tableData: tableData,
			uploadFiles: uploadFilesTmpEnd
		});
	};

	onDrop(files, rejected, evt) {
		let items = evt.dataTransfer? evt.dataTransfer.items: null;
		let reading = 0, reading2 = 0;
		var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

		function scanFiles(entry) {
			console.log("Nested ", entry);
			reading2++;
			if (entry.isFile)
				entry.file((file) => {
					file.fullPath = entry.fullPath;
					files.push(file);
					reading2--
				}, (error) => {
					console.error("Cannot convert to file", entry);
					reading2--
				});
			else {
				reading2--;
				let directoryReader = entry.createReader();
				directoryReader.readEntries(function(entries) {
					entries.forEach((entry) => scanFiles(entry));
				});
			}
		}

		for(let index = 0; index < files.length; index++) {
			const file = files[index];
			const bytes = file.size;
			if (bytes === 0) {
				files.splice(index, 1);
				continue;
			}
			var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
			file.formatSize = Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
			file.key = index;
			if (items && items[index].webkitGetAsEntry) {
				const item = items[index].webkitGetAsEntry();
				if (item && item.isDirectory) {
					files.splice(index, 1);
					reading++;
					item.createReader().readEntries(function(entries) {
						entries.forEach(function(entry) {
							scanFiles(entry);
						});
						reading--;
					});
				}
			}
		}
		const continueUpload = this.uploadFiles;
		if (reading === 0)
			continueUpload(files);
		else {
			function checkDone() {
				if (reading > 0 || reading2 > 0)
					window.setTimeout(checkDone, 100);
				else {
					if (files.length === 0)
						console.log("No files to upload");
					else
						continueUpload(files);
				}
			}
			checkDone();
		}
	}

	uploadFiles = (files) => {
		console.log('AssetsFinal', files);
		
        this.setState({
            tableData: files,
            uploadFiles: files,
            files
        });
        this.handleOk(files);
	};


	handleOk = (uploadFiles) => {
        //this.setState({visible: true})
        const {loadConfig , translations} = this.props;
        let maxSize = loadConfig['web.uploadasset.maxsize'];
        const upload = checkMaxFileSize(uploadFiles , maxSize);
        if(upload){
            const modal = Modal.info({
                title: this.state.translations.assetUpload,
                okButtonProps:{disabled:true},
                content: <div className="text-center"><span data-translationkey="uploadingFiles" className="d-none">{this.state.translations.uploadingFiles}</span><img className="loading-cube" src={Cube} alt="loading" /></div>,
                footer: null
            });
            if(this.props.uploadingAssets)
                this.props.uploadingAssets();
            const matspecId = this.props.materialSpecificationId;
            const admaterialId = this.props.specId;
            const newAssetIds = [];
            const uploadFilesLength = uploadFiles.length;
            let uploadResponse = 0;
            this.props.unsubmittedChanges(true);
            this.setState({processing: true})
            for(let i = 0; i < uploadFiles.length; i++) {
                const formData = new FormData();
                formData.append('matspec', matspecId);
                formData.append("file", uploadFiles[i]);
                if(this.props.setAsVisual){
                    formData.append("type", "VISUAL");
                }
                fetch(urlPath + '/api/assetsave',
                        {method: 'POST', body: formData, credentials: 'include', headers: getAuthHeader()})
                    .then(handleErrors)
                    .then(response => response.text())
                    .then(response => {
                        let assetId = response;
                        /*/assetsave does not use JSON any more
                         if(assetId.includes('attach')){
                            assetId = JSON.parse(assetId);
                            assetId = assetId.attach;
                        }*/
                        console.log('Saved Asset.' + assetId + ' saved on MaterialSpecification.' + matspecId);
                        uploadResponse++;
                        newAssetIds.push(assetId);
                        //this.setState({visible: false})

                        if(uploadResponse === uploadFilesLength){
                            this.props.setNewAssets(admaterialId?admaterialId:null, newAssetIds , matspecId);
                            if(this.props.loadAssets){
                                this.props.loadAssets();
                            }
                            if(this.props.setAsVisual){
                                this.props.reloadReport(true);
                            }
                            modal.destroy();
                        }
                        this.setState({processing: false})
                    })
                    .catch(e => {console.error("Cannot save asset!", e);this.setState({processing: false})});
            }
        }else{
            Modal.error({
                title: 'Error',
                content: translations.fileSizeExceeded + ": " + maxSize + ' MB'
            });
        }
	};


	render() {
		const {translations} = this.props;
		let id = 'drop-assets.' + this.props.specId;
		return (
            <span className="asset-upload-root" data-id={this.props.specId}>

            <div className="droparea-container" data-id={this.props.specId}>
                <PreloadingMask text={translations.processing} visible={this.state.processing} />
                <span id={id} className="droparea-dropzone-container droparea-dropzone-container-big" data-id={this.props.specId}>
                    <div className="droparea">
                        <form encType="multipart/form-data" action="">
                            <Dropzone className="droparea-dropzone" onDrop={this.onDrop.bind(this)} onDrop={this.onDrop.bind(this)} onClick={() => highlightMaterial(this.props.specId)}>
                                <div className="droparea-icons">
                                    <span>
                                            <Icon type="file-add"/>
                                        </span>
                                </div>
                                <span className="droparea-text">{translations.dropAssets}</span>
                                <span>{translations.or}</span>
                                <Button type="primary">{translations.browse}</Button>
                            </Dropzone>
                        </form>
                    </div>
                </span>
            </div>
                <Modal
                  title='Asset'
                  visible={this.state.visible}
                  footer={null}
                >
                  <p data-translationkey="uploadingAssets" style={{padding: '25px'}}>{this.props.translations?this.props.translations.uploadingAssets:'Uploading assets...'}</p>
                </Modal>
            </span>
		);
	}

	componentDidMount() {
		/*if (this.props.status)
			hasPermission("com.ix.adp.model.Asset.create", this.props.status, val => {
				if (!val) {
					let elem = document.getElementById("drop-assets." + this.props.specId);
					if (elem)
						elem.classList.add('v-hidden');
				}
			});*/
	}

	componentWillUnmount() {
		this.isCancelled = true;
	}
}

export default AssetUploadBig;


// WEBPACK FOOTER //
// ./src/components/AssetUploadBig.js